import script from "./message-bubble-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-bubble-web.vue?vue&type=script&lang=ts&setup=true"

import "./message-bubble-web.vue?vue&type=style&index=0&id=7f7c8c72&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7c8c72"]])

export default __exports__